import React from 'react';
import { Box, Grid, Typography, Stack, CardMedia } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const InspectionComparison = () => {
  const localPoints = [
    { text: '🔍 Limited checks, often less than 30 points', icon: <InfoOutlinedIcon color="disabled" /> },
    { text: '❌ No written report or warranty', icon: <CancelIcon sx={{ color: 'red' }} /> },
    { text: '🧰 Skill level varies from mechanic to mechanic', icon: <InfoOutlinedIcon color="disabled" /> },
    { text: '🤝 No accountability after purchase', icon: <CancelIcon sx={{ color: 'red' }} /> },
    { text: '🚫 Hidden issues can go unnoticed', icon: <CancelIcon sx={{ color: 'red' }} /> },
    { text: '📄 Inspection not stored or verifiable', icon: <CancelIcon sx={{ color: 'red' }} /> },
  ];

  const focusPoints = [
    { text: '✅ 130+ point expert checklist', icon: <CheckCircleIcon sx={{ color: 'green' }} /> },
    { text: '📝 Detailed digital inspection report', icon: <CheckCircleIcon sx={{ color: 'green' }} /> },
    { text: '🛠️ Certified and trained technicians', icon: <CheckCircleIcon sx={{ color: 'green' }} /> },
    { text: '🛡️ Warranty assurance on inspected components', icon: <CheckCircleIcon sx={{ color: 'green' }} /> },
    { text: '📞 Dedicated customer support and post-check help', icon: <CheckCircleIcon sx={{ color: 'green' }} /> },
    {
      text: '📱 QR-enabled online reports—easily shareable and verifiable',
      icon: <CheckCircleIcon sx={{ color: 'green' }} />,
    },
  ];

  return (
    <Box sx={{ px: 2, pt: 4, pb: 2, backgroundColor: 'white' }}>
      <Grid container spacing={2} justifyContent="center">
        {/* Local Mechanic */}
        <Grid item xs={6} md={5}>
          <Box sx={{ backgroundColor: '#fff', borderRadius: 2, minHeight: '100%' }}>
            <CardMedia
              component="img"
              className=""
              src="assets/images/Inspection/localCar.webp"
              alt="Card Image"
              // height={isMobile ? 25 : 40}
              sx={{ objectFit: 'contain', borderRadius: '10px' }}
            />
            <Stack mx={2}>
              <Typography fontSize="12px" mt={2} fontWeight="bold" color="#989898" mb={2}>
                Without Certified Inspection (Local Mechanic)
              </Typography>
              <Stack spacing={2}>
                {localPoints.map((point, i) => (
                  <Box key={i} display="flex" alignItems="center" gap={1}>
                    {/* {point.icon} */}
                    <Typography fontSize="10px" color="#989898">
                      {point.text}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Stack>
          </Box>
        </Grid>

        {/* FOCUS Inspection */}
        <Grid item xs={6} md={5}>
          <Box sx={{ backgroundColor: '#fff', borderRadius: 2, minHeight: '100%' }}>
            <CardMedia
              component="img"
              className=""
              src="assets/images/Inspection/focus.webp"
              alt="Card Image"
              // height={isMobile ? 25 : 40}
              sx={{ objectFit: 'contain', borderRadius: '10px' }}
            />
            <Stack mx={2}>
              <Typography fontSize="12px" fontWeight="bold" mt={2} color="#F9610C" mb={2}>
                With FOCUS <br />
                Certified <br /> Inspection
              </Typography>
              <Stack spacing={2}>
                {focusPoints.map((point, i) => (
                  <Box key={i} display="flex" alignItems="center" gap={1}>
                    {/* {point.icon} */}
                    <Typography fontSize="10px" color="black">
                      {point.text}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InspectionComparison;
